import React, { useContext } from "react";
import TabBar, { TabBarProps } from "../../../../shared/components/TabBar";
import FormContainer from "../Content/FormContainer/index";
import MaterialStandard from "../../create/Content/MaterialStandard";
import TransactionHistory from "../../create/Content/Transaction History";
import { Product } from "../../../../data/entities";
import ProductExtraFees from "../../create/Content/ProductExtraFee";
import { AuthenticationContext } from "../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../data/enums";
import { ProductCustomerTab } from "../../create/Content/Customer";

interface TabNavigationProps {
    validated: boolean;
    productData: Product;
    onSubmit?: (data: any) => void;
    mergeProduct: Function;
}

const TabNavigation = ({
                           validated,
                           productData,
                           onSubmit,
                           mergeProduct,
                       }: TabNavigationProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const tabs: TabBarProps[] = [
        {
            label: "Thông tin",
            labelEN: "info",
            content: (
                <FormContainer
                    validated={validated}
                    productData={productData}
                    mergeProduct={mergeProduct}
                    onSubmit={onSubmit}
                />
            ),
        },
        {
            label: "Định Mức Vật Tư",
            labelEN: "quantity-formula",
            content: (
                <MaterialStandard
                    materials={productData.materials as any}
                    mergeMaterial={mergeProduct}
                />
            ),
        },
        {
            label: "Chi phí kèm theo",
            labelEN: "extra-fee",
            content: (
                <ProductExtraFees
                    extraFees={productData.extra_fees}
                    mergeProduct={mergeProduct}
                    category={productData.category}
                />
            ),
        },
        {
            label: "Khách hàng",
            labelEN: "customers",
            content: (
                <ProductCustomerTab
                    customers={productData.customers || []}
                    defaultPrice={0}
                    mergeProduct={mergeProduct}
                />
            ),
        },
        {
            label: "Lịch sử Xuất/Nhập",
            labelEN: "export-import-log",
            content: <TransactionHistory productId={productData.id} />,
        },
    ];

    const getTabs = () => {
        switch (role) {
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
                return tabs.filter(
                    (tab) =>
                        !["extra-fee", "customers"].includes(
                            tab.labelEN as string,
                        ),
                );

            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
                return tabs.filter(
                    (tab) =>
                        !["extra-fee", "export-import-log", "customers"].includes(
                            tab.labelEN as string,
                        ),
                );
            case ROLE.DELIVERER:
                return [];
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.FACTORY_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
                return tabs;
            case ROLE.SALE_MANAGER:
            case ROLE.SALE_STAFF:
                return tabs.filter((tab) => tab.labelEN !== "quantity-formula");
        }
    };

    return <TabBar tabs={getTabs()} />;
};

export default TabNavigation;
